import { useCallback, useMemo } from 'react';
import OrderFullscreenModal from './common/OrderFullscreenModal';
import { useOrderRemoteCollaboration } from '../../../../hooks/order/useOrderRemoteCollaboration';
import { useOrderContext } from '../../../../providers/OrderProvider';
import OrderFullscreenModalBody from './common/OrderFullscreenModalBody';
import OrderModalFooter from './common/OrderModalFooter';
import OrderModalHeader from './common/OrderModalHeader';
import OrderDetailModalBody from './common/OrderDetailModalBody';

const DeliveryModal = ({ setIsOpenPendingModal, isOpenPendingModal }) => {
	const { order, isLoading } = useOrderContext();
	const { handleRemoteOrderUpdate } = useOrderRemoteCollaboration('delivery', {
		enabled: isOpenPendingModal,
	});
	const { orderId, customerInfo, approvalStatus, isCompleted } = order ?? {};

	const handleClose = useCallback(() => {
		setIsOpenPendingModal(false);
	}, [setIsOpenPendingModal]);

	const deliveryStatusBadge = useMemo(() => order?.uiHints?.modalStatusBadges?.default ?? null, [order]);

	return (
		<OrderFullscreenModal show={isOpenPendingModal} onHide={handleClose}>
			<OrderModalHeader
				orderId={orderId}
				customerInfo={customerInfo}
				isLoading={isLoading}
				isCompleted={isCompleted}
				approvalStatus={approvalStatus}
				badges={deliveryStatusBadge ? [deliveryStatusBadge] : []}
			/>
			<OrderFullscreenModalBody isLoading={isLoading}>
				<OrderDetailModalBody
					pendingFocus='delivery'
					notesType='delivery'
					showOrderProgress
					contractTooltipId='delivery-contract-toggle-tooltip'
					invoiceTooltipId='delivery-invoice-toggle-tooltip'
				/>
			</OrderFullscreenModalBody>
			<OrderModalFooter onRemoteOrderUpdate={handleRemoteOrderUpdate} />
		</OrderFullscreenModal>
	);
};

export default DeliveryModal;
